import { useState, useEffect, useCallback } from "react";

const useToggleAgentIQChat = () => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (isOpen) {
      window?.__aiq?.renderChat();
      window?.__aiq?.openChatWindow();
    } else {
      window?.__aiq?.closeChatWindow();
    }
  }, [isOpen]);

  const onToggle = useCallback(() => {
    setIsOpen((prev) => !prev);
  }, []);

  return { isOpen, onToggle };
};

export default useToggleAgentIQChat;
